import { request } from '../core';
import { buildURL, Method } from '../core/util';
import $ from 'jquery';
class ShadowSystemApi {
  /**
   * 通过经纬度获取逆地址
   * @param {string} latLon 经纬度拼接成的字符串
   * @return {Object} promise
   */
  public getInverseAddressAsync = (latLon: string): Promise<any> => {
    if (!process.env.JDX_APP_TENCENT_MAP_KEY) return Promise.resolve(null);
    return new Promise((resolve, reject) => {
      $.ajax({
        type: 'get',
        url: buildURL({
          absoluteURL: 'https://apis.map.qq.com/ws/geocoder/v1/',
          urlParams: {
            key: process.env.JDX_APP_TENCENT_MAP_KEY!,
            location: latLon,
            output: 'jsonp',
          },
        }),
        dataType: 'jsonp',
        success: (res: any) => {
          if (res.status == 0) {
            resolve(res?.result);
          } else {
            resolve(null);
          }
        },
        fail: (error: any) => {
          resolve(null);
        },
      });
    });
  };

  /**
   * 查询事件关联数据
   * @param {string} type
   * @param {string | number} eventId
   * @return {Promise}
   */
  public getEventLinkView = async (type: string, eventId: string | number) => {
    const requestParam: RequestOptions = {
      method: Method.POST,
      path: `/shadow/web/event/detail`,
      body: {
        eventId,
      },
    };
    return request(requestParam);
  };
  public getEventLink = async (type: string, eventId: string | number) => {
    const requestParam: RequestOptions = {
      method: Method.POST,
      path: `/shadow/web/event/link/view`,
      body: {
        type,
        id: eventId,
      },
    };
    return request(requestParam);
  };
  public getFrontCamPlayBackUrl = async (params: {
    terminalId: string;
    direction: string;
    startTimeStr: string;
    operator: string;
  }) => {
    const requestParam: RequestOptions = {
      method: 'POST',
      path: '/monitor/web/video/process/history/contain',
      body: params,
    };
    return request(requestParam);
  };
  public getRealtimeData = async (eventId: string | number) => {
    const requestParam: RequestOptions = {
      method: 'POST',
      path: '/shadow/web/realtime/event',
      body: {
        id: eventId,
      },
    };
    return request(requestParam);
  };

  public getInverseAddress = async (lonLatString: string) => {
    const res = await this.getInverseAddressAsync(lonLatString);
    return res;
  };

  /**
   * 请求城市、站点、及站点下的车辆列表
   * @return {Promise}
   */
  public fetchCityAndStationList = async (): Promise<any> => {
    const requestParam: RequestOptions = {
      method: Method.POST,
      path: '/monitor/web/basic/user_metadata',
      body: {
        dataType: 'city',
      },
    };
    return request(requestParam);
  };

  /**
   * 获取用户权限下所有车辆
   * @return {Promise}
   */
  public fetchVehicleList = async (): Promise<any> => {
    const requestParam: RequestOptions = {
      method: Method.POST,
      path: '/monitor/web/basic/user_metadata',
      body: {
        dataType: 'vehicle',
      },
    };
    return request(requestParam);
  };

  /**
   * 根据traceId获取事件跟踪列表
   * @param {object} param 请求参数
   * @param {string} param.vehicleName 车号
   * @param {string} param.startTime 开始时间
   * @param {string} param.endTime 结束时间
   * @return {Promise}
   */
  public fetchTableListByTraceId = async (param: {
    vehicleName: string;
    startTime: string;
    endTime: string;
  }): Promise<any> => {
    const requestParam: RequestOptions = {
      method: Method.POST,
      path: '/shadow/web/event/list',
      body: param,
    };
    return request(requestParam);
  };

  /**
   * 手动提取视频
   * @param {number} eventId 事件id
   * @return {Promise}
   */
  public syntheticVideo = (eventId: number) => {
    return request({
      method: Method.POST,
      path: '/shadow/web/video/synthetic',
      body: {
        id: eventId,
      },
    });
  };

  /**
   * 获取指令名称列表
   * @param {string} eventSource 事件来源
   * @return {Promise}
   */
  public fetchEventTypeNameList = async (
    eventSource?: string,
  ): Promise<any> => {
    const requestParam: RequestOptions = eventSource
      ? {
          method: Method.POST,
          path: '/shadow/web/event/type/list',
          body: {
            eventSource: eventSource,
          },
        }
      : {
          method: Method.POST,
          path: '/shadow/web/event/type/list',
        };
    return request(requestParam);
  };

  /**
   * 查询通用枚举列表
   * @param {string[]} param 请求参数
   * @return {Promise}
   */
  public fetchEnumListMap = async (param: string[]): Promise<any> => {
    const requestParam: RequestOptions = {
      method: Method.POST,
      path: '/shadow/web/enum/get_enum_list_map',
      body: {
        keyList: param,
      },
    };
    return request(requestParam);
  };

  /**
   * 车辆调度查询
   * @param {object} param 请求参数
   * @param {string} param.startTime 开始时间（必选）
   * @param {string} param.endTime 结束时间（必选）
   * @param {number} param.pageNum （必选）
   * @param {number} param.pageSize （必选）
   * @param {string} param.cityName 城市名（可选）
   * @param {string} param.stationName 站点名（可选）
   * @param {string} param.vehicleName 车号（可选）
   * @return {Promise}
   */
  public fetchScheduleList = async (param: {
    startTime: string;
    endTime: string;
    pageNum: number;
    pageSize: number;
    cityName?: string;
    stationName?: string;
    vehicleName?: string;
  }): Promise<any> => {
    const requestParam: RequestOptions = {
      method: Method.POST,
      path: '/shadow/web/analy/schedule/page',
      body: param,
    };
    return request(requestParam);
  };

  /**
   * 车辆启动列表查询
   * @param {object} param 请求参数
   * @param {string} param.startTime 开始时间（必选）
   * @param {string} param.endTime 结束时间（必选）
   * @param {number} param.pageNum （必选）
   * @param {number} param.pageSize （必选）
   * @param {string} param.stationId 站点Id（必选）
   * @param {string} param.cityName 城市名（可选）
   * @param {string} param.stationName 站点名（可选）
   * @param {string} param.vehicleName 车号（可选）
   * @return {Promise}
   */
  public fetchBootList = async (param: {
    startTime: string;
    endTime: string;
    pageNum: number;
    pageSize: number;
    stationId: string;
    cityName?: string;
    stationName?: string;
    vehicleName?: string;
  }): Promise<any> => {
    const requestParam: RequestOptions = {
      method: Method.POST,
      path: '/shadow/web/analy/boot/list',
      body: param,
    };
    return request(requestParam);
  };

  /**
   * @param {object} param 请求参数
   * @param {string} param.vehicleName 车牌号（必选）
   * @param {string} param.bootUUId 启动UUID（必选）
   * @param {string} param.startTime 启动开始时间（必选）
   * @param {string} param.endTime 启动结束时间（必选）
   * @return {Promise}
   */
  public fetchBootDetail = async (param: {
    vehicleName: string;
    bootUUID: string;
    startTime: string;
    endTime: string;
  }): Promise<any> => {
    const requestParam: RequestOptions = {
      method: Method.POST,
      path: '/shadow/web/analy/boot/module/list',
      body: {
        vehicleName: param.vehicleName,
        bootUUID: param.bootUUID,
        startTime: param.startTime,
        endTime: param.endTime,
      },
    };
    return request(requestParam);
  };

  /**
   * 获取调度热力图数据（事件）
   * @param {object} param 请求参数
   * @param {string} param.scheduleName 调度单号
   * @param {string} param.moduleCode 模型Code
   * @param {string} param.vehicleName  车号
   * @param {string} param.stationId  站点Id
   * @return {Promise}
   */
  public fetchHotSpotEvent = async (param: {
    moduleCode: string;
    vehicleName?: string;
    stationId?: string;
    startTime?: string;
    endTime?: string;
    scheduleName?: string;
  }): Promise<any> => {
    const requestParam: RequestOptions = {
      method: Method.POST,
      path: '/shadow/web/analy/hotspot/event',
      body: {
        moduleCode: param.moduleCode,
        scheduleName: param.scheduleName ?? null,
        vehicleName: param.vehicleName ?? null,
        stationId: param.stationId ?? null,
        startTime: param.startTime ?? null,
        endTime: param.endTime ?? null,
      },
    };
    for (const key in requestParam.urlParams) {
      if ([null, undefined, ''].includes(requestParam.urlParams[key])) {
        delete requestParam.urlParams[key];
      }
    }
    return request(requestParam);
  };
  /**
   * 获取调度热力图数据（实时路径与规划路径）
   * @param {object} param 请求参数
   * @param {string} param.scheduleName 调度单号
   * @param {string} param.moduleCode 模型Code
   * @return {Promise}
   */
  public fetchHotSpotRoute = async (param: {
    scheduleName: string;
    moduleCode: string;
  }): Promise<any> => {
    const requestParam: RequestOptions = {
      method: Method.POST,
      path: '/shadow/web/analy/schedule/hotspot_route',
      body: {
        scheduleName: param.scheduleName,
        moduleCode: param.moduleCode,
      },
    };
    return request(requestParam);
  };

  /**
   * 提交路段监控事件
   * @param {object} param 请求参数
   * @param {string} param.vehicleName 车号
   * @param {string} param.startTime 开始时间
   * @param {string} param.endTime 结束时间
   * @parma {string} param.reportTime
   * @return {Promise}
   */
  public addManualEvent = async (param: {
    vehicleName: string;
    startTime?: string;
    endTime?: string;
    reportTime?: string;
  }): Promise<any> => {
    const requestParam: RequestOptions = {
      method: 'POST',
      path: '/shadow/web/event/add_manual_event',
      body: {
        eventType: 'SHADOW_ROAD_MONITOR',
        ...param,
      },
    };
    return request(requestParam);
  };
  public getDirectionCamPlayBackUrl = async (params: {
    terminalId: string;
    direction: string;
    startTimeStr: string;
    operator: string;
  }) => {
    const requestParam: RequestOptions = {
      method: 'POST',
      path: '/monitor/web/video/process/history/contain',
      body: params,
    };
    return request(requestParam);
  };
  /**
   * 获取前路摄像头视频截图
   * @param {object} param
   * @param {string} param.terminalId 车号
   * @param {string} param.direction 方向
   * @param {string} param.picTimeStr 截取图片的时间
   * @param {string} param.originator 当前登录的用户名
   * @param {string} param.usageType 截取图片用途，暂填DEV
   * @return {Promise}
   */
  public fetchFrontCamSnapshot = async (param: {
    terminalId: string;
    direction: string;
    picTimeStr: string;
    originator: string;
    usageType: string;
  }): Promise<any> => {
    const requestParam: RequestOptions = {
      method: 'POST',
      path: '/video/process/snapshot/request',
      body: param,
      timeout: 30000,
    };
    return request(requestParam);
  };

  /**
   * KPI分析---图表横纵坐标筛选框列表
   * @param {object} param 请求参数
   * @param {string} param.scheduleName 调度单号
   * @param {string} param.moduleCode 模型Code
   * @param {string} param.chartType  图表类型
   * @param {string | null} param.xAxisCode 横坐标数据
   * @param {string | null} param.yAxisCode 纵坐标数据
   * @return {Promise}
   */
  public fetchChartAxis = async (param: {
    scheduleName: string;
    moduleCode: string;
    chartType: string;
    xAxisCode: string | null;
    yAxisCode: string | null;
  }): Promise<any> => {
    const requestParam: RequestOptions = {
      method: Method.POST,
      path: '/shadow/web/analy/chart/axis',
      body: param,
    };
    return request(requestParam);
  };

  /**
   * KPI分析---获取图表数据
   * @param {object} param 请求参数
   * @param {string} param.scheduleName 调度单号
   * @param {string} param.xAxis 横坐标
   * @param {string} param.yAxis 纵坐标
   * @param {string} param.moduleCode 模型Code
   * @param {string} param.vehicleName 车牌号
   * @return {Promise}
   */
  public fetchChartData = async (param: {
    scheduleName: string;
    xAxisCode: string;
    yAxisCode: string;
    chartType: string;
    moduleCode: string;
    vehicleName: string;
  }): Promise<any> => {
    const requestParam: RequestOptions = {
      method: Method.POST,
      path: '/shadow/web/analy/chart/data',
      body: param,
    };
    return request(requestParam);
  };
}

export default ShadowSystemApi;
